import React, { useEffect, useState } from "react";
import style from "./Finishedchats.module.css";
import { MdAddComment } from "react-icons/md";
import { collection, deleteDoc, doc, getDocs } from "firebase/firestore";
import { db } from "../../firebase/config";
import Chatscard from "./Chatscard";
const Finishedchats=()=>{
    const [chats,setChats]=useState([]);
    useEffect(()=>{
        const fetchchats= async()=>{
            const querySnapshot = await getDocs(collection(db, "finishedchats"));
            const demo = [];
            querySnapshot.forEach((doc) => {
                demo.push(doc.data());
                setChats([...chats,...demo]);  
            });
        }
        fetchchats();
    },[])
    console.log(chats)
    const deletechat = async(id)=>{
        await deleteDoc(doc(db, "messages", id));
        await deleteDoc(doc(db, "roomuser", id));
        await deleteDoc(doc(db, "finishedchats", id));
        setChats(chats.filter((e)=>e.uid!==id));
    }
    return(
        <div className={style.container}>
            <div className={style.chatsnav}>
                <p>جميع الشاتات المخصصه بالمشاريع المنتهيه</p>
                <MdAddComment size={48}/>
            </div>
            <div className={style.allchats}>
                {chats.map((chat)=>{
                    return(
                        <Chatscard deletechat={deletechat} key={chat.uid} chat={chat} finish={true}/>
                    ) 
                })}
            </div>
        </div>
    )
}
export default Finishedchats;